import React from "react";
import { Typography } from "@mui/material";
import TopSection from "../../Components/Common/Top/TopSection";
import UserManagement from "./UserManagement";

const ManageUsers = () => {
  return (
    <>
      <TopSection
        labelList={[
          { title: "Home", path: "/dashboard" },
          { title: "History" },
        ]}
        title="Manage Users"
      />
      <div className="container">
        <UserManagement />
      </div>
    </>
  );
};

export default ManageUsers;
